import BackgroundLocationPage from "./BackgroundLocation";
import TermsPage from "./TermsPage";

const PoliciesPage = () => {
  return (
    <>
      <article
        className={`prose lg:prose-lg dark:prose-invert mx-auto p-6 bg-white dark:bg-neutral-900 rounded-2xl shadow-sm `}
      >
        <header>
          <h1 className="text-2xl font-semibold">
            Política de Privacidad y Protección de Datos
          </h1>
          <p className="text-sm text-neutral-500">
            BEEAPP ECUADOR CIA.LTDA — Política sobre el tratamiento de datos
            personales
          </p>
        </header>

        <section>
          <p>
            La Compañía legalmente constituida “BEEAPP ECUADOR CIA.LTDA” a quien
            en adelante se le denominará como “BEEAPP” pone a conocimiento e
            informa a sus usuarios respecto a la Política de privacidad y
            Protección de datos con la que se tratarán los datos personales
            proporcionados de manera voluntaria al hacer uso de su aplicación
            móvil y/o página web.
          </p>
        </section>
        <section>
          <h2>Primera. - Introducción</h2>
          <p>
            Los datos personales que el usuario entrega al registrarse y/o usar
            nuestra aplicación y/o plataforma web nos demuestran la confianza
            que depositan en BEEAPP es por ello que ponemos a su conocimiento
            nuestra política de privacidad, mediante la cual explicamos los
            datos personales que se recopilan, la forma en que serán usados y
            compartidos, y sus opciones respecto a dicha información.
          </p>
        </section>

        <section>
          <h2>
            Segunda. - Responsable de la recopilación, almacenamiento y
            tratamiento de datos personales
          </h2>
          <p>
            <strong>BEEAPP ECUADOR CIA.LTDA</strong> es la responsable de la
            recopilación de los datos personales así como también del
            almacenamiento, uso y tratamiento de los mismos que devienen del uso
            de los servicios brindados por BEEAPP.
          </p>
        </section>

        <section>
          <h2>Tercera. - Datos personales que se recopilan</h2>
          <p>BEEAPP recopila y almacena los siguientes datos personales</p>
          <details className="mb-4" open>
            <summary className="cursor-pointer font-medium">
              3.1 Datos proporcionados por el usuario
            </summary>
            <div className="mt-2">
              <p>
                BEEAPP recopila todos los datos que el usuario proporciona al
                momento de crear su perfil, modificarlo, iniciar sesión,
                consultar información, interactuar con un repartidor o
                establecimiento comercial, esta información puede ser:
              </p>
              <ul>
                <li>
                  Nombres, apellidos, fecha de nacimiento, correo electrónico,
                  nombre de usuario y contraseña.
                </li>
                <li>Foto de perfil y número telefónico.</li>
                <li>
                  Datos demográficos del usuario, de usuarios de terceros.
                </li>
              </ul>
            </div>
          </details>

          <details className="mb-4">
            <summary className="cursor-pointer font-medium">
              3.2 Datos provenientes del uso de BEEAPP
            </summary>
            <div className="mt-2">
              <ul>
                <li>
                  <strong>Datos de ubicación:</strong> El usuario debe dar la
                  respectiva autorización en el sistema operativo de su
                  dispositivo móvil para que BEEAPP tenga acceso la información
                  relacionada a la ubicación del dispositivo móvil del usuario,
                  estos datos son recopilados cuando la aplicación se esté
                  ejecutando en primer plano, así como en segundo plano cuando
                  sea necesario.
                </li>
                <li>
                  <strong>Datos sobre la orden:</strong> BEEAPP recopila la
                  información respecto al pedido realizado por el usuario, tipo
                  de producto o servicio, cantidad, frecuencia de consumo, fecha
                  y hora, preferencia de productos o servicios consumidos.
                </li>
                <li>
                  <strong>Datos sobre la transacción:</strong> BEEAPP recopila
                  la forma en la que se realiza el pago, número de tarjeta de
                  débito o crédito usada en la transacción, fecha y hora en la
                  que se realiza el pago, monto de pago y cualquier información
                  relacionada con la transacción.
                </li>
                <li>
                  <strong>Datos del dispositivo:</strong> El tipo de dispositivo
                  utilizado, información sobre el Hardware y Software, dirección
                  IP del dispositivo y acceso al sistema de geolocalización.
                </li>
                <li>
                  <strong>Datos recopilados del uso del perfil:</strong> BEEAPP
                  recopila toda la interacción que el usuario realiza a través
                  de su perfil, esto es información como fecha y hora de acceso,
                  páginas visitadas, pedidos realizados, fallas de la aplicación
                  y otras actividades del sistema.
                </li>
                <li>
                  <strong>Datos de Feedback:</strong> BEEAPP recopila toda la
                  información proporcionada a través de sus distintos canales de
                  comunicación, servicio y soporte al cliente, calificación y
                  comentarios sobre la aplicación, calificación y comentarios
                  sobre el motorizado, calificación y comentarios sobre el
                  establecimiento, calificación y comentarios sobre cualquier
                  producto o servicio.
                </li>
                <li>
                  <strong>
                    Datos obtenidos de tecnologías de investigación:
                  </strong>{" "}
                  BEEAPP recopila información a través del uso de tecnologías de
                  investigación utilizadas por si mismos o terceros (pueden ser
                  cookies o cualquier otra) las cuales requieren de autorización
                  por parte del usuario quien podrá aceptar o no, sin embargo,
                  el usuario debe saber que las tecnologías de investigación
                  utilizadas permiten un óptimo desarrollo del uso aplicación.
                </li>
              </ul>
            </div>
          </details>

          <details className="mb-4">
            <summary className="cursor-pointer font-medium">
              3.3 Datos de otras fuentes
            </summary>
            <div className="mt-2">
              <p>
                BEEAPP puede recopilar datos personales a través de la
                información recibida de los motorizados, establecimientos
                comerciales, fuentes públicas, proveedores de servicios de
                marketing.
              </p>
              <p>
                BEEAPP puede recopilar datos personales cuando los usuarios se
                conecten a la aplicación a través de otras plataformas web o
                cuando son redireccionados hacia la aplicación.
              </p>
            </div>
          </details>
        </section>

        <section>
          <h2>Cuarta. - Uso de cookies y/o tecnologías de investigación</h2>
          <p>
            Las cookies son archivos de reducida dimensión que los sitios web
            colocan en el dispositivo y navegador para monitorear la actividad
            del navegador y los hábitos de navegación. BEEAPP utiliza cookies o
            similares tecnologías con la siguiente finalidad:
          </p>
          <ul>
            <li> Verificar el perfil de los usuarios</li>
            <li> Analizar las preferencias de consumo de los usuarios</li>
            <li> Direccionar publicidad</li>
            <li> Medir la aceptación de productos y servicios.</li>
          </ul>
          <p>
            BEEAPP puede permitir y/o contratar a terceros para que a través de
            cookies u otra tecnología puedan medir el alcance e impacto de la
            aplicación y demás productos y servicios que se consideren
            pertinentes, así como también controlen e informen con respecto a la
            publicidad anunciada en la aplicación.
          </p>
        </section>

        <section>
          <h2>Quinta. - Uso de los datos personales recopilados</h2>
          <p>
            Los datos personales recopilados y almacenados por BEEAPP son
            utilizados para los siguientes fines:
          </p>
          <ul>
            <li>
              Creación, modificación, actualización y autenticación de la cuenta
              de perfil.
            </li>
            <li>Mejorar la seguridad del Usuario y la plataforma de BEEAPP</li>
            <li>
              Conectar al usuario con el establecimiento comercial que ofertan
              bienes y/o servicios.
            </li>
            <li>
              Conectar al usuario con el motorizado a cargo de trasportar el
              producto solicitado.
            </li>
            <li>Facilitar el pago del bien o servicio adquirido.</li>
            <li>
              Rastrear y localizar el estado del envió, el tiempo de entrega
              estimado y el tiempo de duración hasta la entrega final.
            </li>
            <li>
              Enviar información sobre el progreso del envío, pedidos, compras,
              reservas.
            </li>
            <li>
              Analizar y supervisar las preferencias de consumo así como la
              actividad para personalizar la experiencia del usuario.
            </li>
            <li>Corregir errores del software.</li>
            <li>
              Investigación, Desarrollo y Promoción de bienes y servicios
              propios y de terceros.
            </li>
            <li>
              Direccionar publicidad para ofrecer una experiencia personalizada
              al usuario.
            </li>
            <li>
              Analizar y cuantificar los resultados de la publicidad anunciada.
            </li>
            <li>Garantizar y mantener la seguridad de los usuarios</li>
          </ul>
          <p>
            Servicio al Cliente: Los datos personales recopilados servirán para
            dar un adecuada atención al cliente ante algún problema consultado a
            través de los canales de comunicación establecidos por BEEAPP
          </p>
        </section>

        <section>
          <h2>Sexta. - Transferencia y divulgación de información</h2>
          <p>
            Para garantizar el efectivo uso de los servicios que brinda BEEAPP
            es necesario que se transferirán y/o divulguen datos pertinentes a
            terceros en la forma en cómo se detalla a continuación:
          </p>
          <details className="mb-4">
            <summary className="cursor-pointer font-medium">
              6.1 Establecimientos comerciales
            </summary>
            <div className="mt-2">
              Los datos personales serán compartidos con los establecimientos
              autorizados por BEEAPP y que forman parte de su plataforma de
              servicios, con la finalidad conectar a establecimientos y usuarios
              para que puedan realizar su transacción comercial.
            </div>
          </details>

          <details className="mb-4">
            <summary className="cursor-pointer font-medium">
              6.2 Motorizados
            </summary>
            <div className="mt-2">
              Los datos personales son compartidos con el motorizado que es el
              responsable de transportar y llevar al destino final el encargo
              realizado, para así garantizar que el pedido será entregado al
              usuario que lo adquirió a través de su cuenta en la plataforma de
              BEEAPP.
            </div>
          </details>

          <details className="mb-4">
            <summary className="cursor-pointer font-medium">
              6.3 Redes sociales
            </summary>
            <div className="mt-2">
              Los comentarios realizados por los usuarios en las páginas de
              redes sociales de BEEAPP serán disponibles para el público en
              general.
            </div>
          </details>

          <details className="mb-4">
            <summary className="cursor-pointer font-medium">
              6.4 Terceros
            </summary>
            <div className="mt-2">
              <ul>
                <li>Instituciones financieras facilitadoras de pagos.</li>
                <li>Medios electrónicos facilitadores de pagos.</li>
                <li>Proveedores de software.</li>
                <li>Analistas de datos</li>
                <li>
                  Desarrolladores de productos y servicios, publicidad,
                  investigación de tendencias de consumo, marketing.
                </li>
                <li>
                  Prestadores de servicios profesionales como Abogados,
                  Contadores, Asesores y demás que BEEAPP considere necesario.
                </li>
                <li>En caso de negocios societarios.</li>
              </ul>
            </div>
          </details>

          <details className="mb-4">
            <summary className="cursor-pointer font-medium">
              6.5 Reclamos a través de Servicios al cliente.
            </summary>
            <div className="mt-2">
              Ante un reclamo realizado por un usuario serán compartidos los
              datos personales para que BEEAPP pueda tomar los correctivos
              necesarios ante la queja o insatisfacción manifestada por el
              usuario.
            </div>
          </details>

          <details className="mb-4">
            <summary className="cursor-pointer font-medium">
              6.6 Requerimientos legales o judiciales
            </summary>
            <div className="mt-2">
              <p>
                BEEAPP a petición o requerimiento legal o judicial entregará a
                la autoridad competente la información que sea solicitada, esto
                implica cualquier autoridad gubernamental que así lo exija, ya
                sea que se trate para cumplir una normativa vigente, solicitar
                permisos, en caso de litigios o demandas por la prestación de
                nuestros servicios o se haya afectado a los derechos y seguridad
                de terceros. Cuando un usuario haga uso de una tarjeta de débito
                o crédito que no le pertenece, se entregara toda la información
                necesaria respecto a la transacción y del titular de la tarjeta
                en cuestión.
              </p>
            </div>
          </details>
        </section>

        <section>
          <h2>Séptima. - Atención al cliente</h2>
          <p>
            El usuario de BEEAPP puede contactarse con las oficinas de BEEAPP a
            través de la opción establecida dentro de la aplicación denominada{" "}
            <strong>AYUDA</strong> con su (identificación del pedido realizado)
            del pedido o al correo electrónico
            <a href="mailto:info@correos-bee.com" className="ml-1 underline">
              info@correos-bee.com
            </a>{" "}
            o por nuestras redes sociales para consultar cualquier duda o
            problema o exponer su queja.
          </p>
        </section>

        <section>
          <h2>Octava. - Modificación y controles de privacidad de la cuenta</h2>
          <ul>
            <li>
              BEEAPP recopila y usa los datos personales proporcionados
              voluntariamente por el usuario. En cualquier momento el usuario
              puede cambiar la configuración de su cuenta dentro de la
              aplicación en caso de considerar que la información es incompleta
              o incorrecta, esto lo puede realizar a través de la opción de
              configuración dentro de la cuenta de usuario.
            </li>
            <li>
              Los diferentes sistemas operativos de los dispositivos móviles
              (Android, iOS) no permiten a la aplicación tener acceso a
              determinada información, es por ello que solicitan el permiso para
              que se pueda acceder a diferentes datos, siendo opción de los
              usuarios conceder o denegar dicho permiso, el uso de la aplicación
              constituye la aceptación del permiso.
            </li>
            <li>
              El usuario puede solicitar a BEEAPP a través de Servicio al
              cliente, tener conocimiento de los datos personales recopilados.
            </li>
            <li>
              El usuario puede revocar su consentimiento para que BEEAPP no
              recopile y use sus datos personales, sin embargo, eso con lleva a
              que el usuario no pueda hacer uso de los servicios o funciones que
              presta BEEAPP en los que es necesario recopilar y usar datos
              personales.
            </li>
            <li>
              El usuario puede solicitar que no se use o se restringa el uso de
              determinado dato personal, sin embargo, en caso de requerimiento
              gubernamental, legal o judicial, pese a la solicitud realizada,
              BEEAPP seguirá almacenando la información.
            </li>
            <li>
              El usuario podrá cancelar la recepción de email con contenido
              publicitario, siguiendo las instrucciones constantes en el mensaje
              recibido. BEEAPP continuara enviado información al correo
              electrónico relacionada con la cuenta de usuario, como por ejemplo
              actividad de la cuenta, pedidos realizados, etc.
            </li>
            <li>
              El usuario en cualquier momento pueden eliminar su cuenta dándola
              de baja dentro de la opción establecida dentro de la cuenta de
              usuario.
            </li>
          </ul>
        </section>

        <section>
          <h2>Novena. - Obligación del usuario</h2>
          <p>
            El usuario se obliga a proporcionar información fidedigna, en
            respeto a terceros y la normativa vigente
          </p>
        </section>

        <section>
          <h2>Décima. - Políticas de pago y devolución</h2>
          <ol>
            <li>
              Las tarifas aplicables al Servicio de Reparto las fijará BEEAPP
              conforme a la demanda de servicios que se encuentre activa en ese
              momento en que el Usuario Registrado haga uso de la Aplicación. El
              Usuario registrado acepta que sea BEEAPP quien fije estas tarifas.
              Estas tarifas serán cobradas directamente por BEEAPP de forma
              automática mediante el Procesador de Pagos o, en su defecto, Por
              el ESTABLECIMIENTO mediante el Motorizado (paga al establecimiento
              el valor de la compra/consumo) quien luego procederá a cobrar al
              Usuario Final (paga el valor de la compra/consumo más el valor del
              servicio de entrega a domicilio) cuando el pago se realice con
              dinero en efectivo. Las tarifas cobradas por el Servicio de
              Reparto no serán reembolsables.
            </li>
            <li>
              Para los casos en los que el Servicio de Reparto sea pagado por el
              Consumidor al Motorizado en efectivo y el monto entregado por el
              Consumidor sea mayor a la tarifa cobrada por el mencionado
              servicio, el Motorizado deberá cumplir con entregarle al
              Consumidor aquel monto sobrante existente entre el monto entregado
              como pago y la tarifa establecida por BEEAPP.
            </li>
            <li>
              En los supuestos en que el Servicio de Reparto se solicite para
              entregar los productos ofrecidos por los Comercios no Aliados, el
              Usuario Registrado adelantará el dinero correspondiente al precio
              de adquisición del producto y BEEAPP lo entregará al Motorizado.
              El Motorizado adquirirá el producto y realizará el pago del precio
              de venta a favor del proveedor por cuenta y orden del Usuario
              Registrado. [BEEAPP brindará toda la información necesaria para
              ello al Usuario Registrado.]
            </li>
            <li>
              Finalizado el Servicio de Reparto, BEEAPP enviará una notificación
              y/o correo electrónico al Usuario Registrado con el resumen del
              trayecto realizado, un detalle de la mercadería efectivamente
              entregada y una descripción de la fecha y hora de entrega y el
              total del monto a abonar con los impuestos incluidos (en adelante,
              el “Resumen”). El Resumen no tendrá validez para efectos
              tributarios ni hará las veces de un comprobante de pago.
            </li>
            <li>
              El titular de la tarjeta de crédito es el responsable por los
              datos consignados al momento de la solicitud y/o reserva del
              Servicio de Reparto seleccionado y es el único obligado al pago
              frente al emisor de la misma. Cualquier desconocimiento deberá ser
              efectuado frente del Banco emisor de la tarjeta de crédito de
              conformidad con lo dispuesto por el Reglamento de Tarjetas de
              Crédito y Débito aprobado mediante Resolución de la Junta de
              Política Monetaria y Financiera No. 463 de Noviembre del 2018.
            </li>
            <li>
              BEEAPP se reserva el derecho de tomar las medidas judiciales y
              extrajudiciales que estime pertinentes para obtener el pago del
              monto debido que pueda adeudar el Usuario Registrado. BEEAPP se
              reserva el derecho de modificar, cambiar, agregar, o eliminar las
              Tarifas Vigentes, en cualquier momento, lo cual será debidamente
              notificado al Usuario Registrado.
            </li>
          </ol>
        </section>

        <section>
          <h2>Undécima. - Actualización</h2>
          <p>
            BEEAPP puede realizar actualizaciones de estas políticas, en caso de
            que considere de realizar cambios significativos en la aplicación o
            página web se notificara a los usuarios a través de sus cuentas de
            usuario y/o correo electrónico. Continuar usando la aplicación se
            considera como aceptación de las actualizaciones realizadas.
          </p>
        </section>

        <section>
          <h2>Duodécima. - Acuerdo de licencia de usuario final</h2>
          <p>
            <em>Última Actualización:</em> 15 de agosto de 2022.
          </p>
          <p>
            Bienvenido y gracias por su interés en Beeapp Ecuador, CIA. LTDA.
            Nuestra tecnología de respuesta de emergencia (Boton de panico
            BeeAPP Ecuador) y cualquier otro servicio para el que se aplican
            estos Términos de uso (el "Servicio Beeapp Ecuador"). Estos Términos
            de uso, es un contrato legalmente vinculante entre usted y BeeAPP
            Ecuador con respecto a su uso del Servicio.
          </p>

          <p className="font-bold">
            POR FAVOR LEA CUIDADOSAMENTE LAS SIGUIENTES CONDICIONES DE USO. AL
            UTILIZAR EL SERVICIO BEEAPP ECUADOR, USTED RECONOCE QUE HA LEÍDO,
            ENTENDIDO Y ACEPTA ESTAR OBLIGADO POR LOS SIGUIENTES TÉRMINOS DE
            USO, INCLUYENDO LA POLÍTICA DE PRIVACIDAD DE BEEAPP ECUADOR Y, EN LA
            MEDIDA QUE CORRESPONDA, LOS TÉRMINOS Y CONDICIONES DE LAS ALERTAS
            (JUNTOS, LOS “TÉRMINOS”). Si no es elegible o no está de acuerdo con
            estos Términos, entonces no tiene nuestro permiso para usar el
            Servicio BEEAPP ECUADOR.
          </p>

          <details className="mb-4">
            <summary className="cursor-pointer font-medium">
              12.1 Descripción general del servicio Beeapp Ecuador.
            </summary>
            <div className="mt-2">
              El servicio Beeapp Ecuador proporciona el servicio de emergencia
              (botón de pánico), para que el usuario pueda compartir su
              ubicación en caso de encontrarse en peligro a sus contactos de
              emergencia, estos números son agregados por el usuario al
              registrarse. Las funciones que se ponen a su disposición a través
              del Servicio Beeapp Ecuador(Botón de pánico) son las
              notificaciones por SMS a los números de emergencia registrados en
              el cual contiene un enlace para el rastreo del dispositivo
              (Tracking).
            </div>
          </details>

          <details className="mb-4">
            <summary className="cursor-pointer font-medium">
              12.2 Servicio Beeapp Ecuador dentro de la plataforma
            </summary>
            <div className="mt-2">
              Es posible que el acceso al Servicio Beeapp Ecuador se haya puesto
              a su disposición como una función separada que forma parte de un
              programa, plataforma o dispositivo ("Plataforma"). Su uso de
              cualquier parte de la Plataforma, que no sea el Servicio Beeapp
              Ecuador, no nos hacemos responsables de ello.
            </div>
          </details>

          <details className="mb-4">
            <summary className="cursor-pointer font-medium">
              12.3 Elegibilidad
            </summary>
            <div className="mt-2">
              <p>
                Debe tener al menos dieciséis (16) años de edad para usar el
                Servicio Beeapp Ecuador. Al aceptar estos Términos, usted
                declara y nos garantiza que:
              </p>
              <ul>
                <li>Tiene al menos dieciséis (16) años de edad.</li>
                <li>
                  No ha sido suspendido o eliminado previamente del Servicio
                  Beeapp Ecuador.
                </li>
                <li>
                  Su registro y su uso del Servicio Beeapp Ecuador cumplen con
                  todas las leyes y reglamentos aplicables. Si está utilizando
                  el Servicio Beeapp Ecuador en nombre de una entidad,
                  organización o empresa, declara y garantiza que tiene la
                  autoridad para vincular a esa organización con estos Términos
                  y acepta estar sujeto a estos Términos en nombre de esa
                  organización.
                </li>
              </ul>
            </div>
          </details>

          <details className="mb-4">
            <summary className="cursor-pointer font-medium">
              12.4 Cuentas y registro
            </summary>
            <div className="mt-2">
              <p>
                Para acceder a la mayoría de las funciones del Beeapp Ecuador,
                debe registrarse para obtener una cuenta y realizar todas las
                funciones de ingreso de datos, ya sea directamente a través de{" "}
                <a href="https://bee.com.ec" className="underline">
                  Beeapp Ecuador
                </a>{" "}
                o a través de las plataformas móviles. Si se registra para
                obtener una cuenta en Beeapp Ecuador, es posible que deba
                proporcionarnos cierta información sobre usted, como su
                dirección de correo electrónico, números de teléfono u otra
                información de contacto. Usted acepta que la información que nos
                proporciona es precisa y que la mantendrá precisa y actualizada
                en todo momento. El Suscriptor será el único y absoluto
                responsable de la información que ingrese, cargue, elimine,
                descargue, modifique y/o monitoree. Beeapp Ecuador otorga al
                Suscriptor una licencia no exclusiva e intransferible para
                acceder a los Servicios Beeapp Ecuador (o parte de los mismos) a
                través de Internet para ingresar, cargar, eliminar, descargar y
                modificar la información del Suscriptor. Excepto por (i) el
                hecho de que el Suscriptor no mantenga confidencial toda la
                información del Suscriptor, (ii) el uso de la licencia o la
                información del Suscriptor de cualquier manera que afecte
                negativamente a Beeapp Ecuador, (iii) el uso de la licencia o la
                información del Suscriptor para cualquier propósito ilegal, (iv)
                violación de cualquier ley aplicable o (v) incumplimiento de
                este Acuerdo por parte del Suscriptor, esta licencia continuará
                durante el Plazo. El Suscriptor acepta que en caso de
                incumplimiento y/o rescisión de este Acuerdo por parte del
                Suscriptor. Si registra su cuenta directamente con Beeapp
                Ecuador, se le pedirá que proporcione una contraseña a Beeapp
                Ecuador. Usted es el único responsable de mantener la
                confidencialidad de su cuenta y contraseña. Independientemente
                de si registró su cuenta con RapidSOS o a través de la
                Plataforma, acepta la responsabilidad de todas las actividades
                que ocurran en el Servicio Beeapp Ecuador en su cuenta. Si tiene
                motivos para creer que su cuenta ya no es segura, debe
                notificarnos de inmediato a{" "}
                <a href="mailto:info@correos-bee.com" className="underline">
                  info@correos-bee.com
                </a>{" "}
              </p>
            </div>
          </details>
        </section>

        <section>
          <h2>
            Décimo tercera. - Términos del servicio de Botón de Pánico (EULA)
          </h2>
          <p>
            <em>Última Actualización:</em> 15 de agosto de 2022. stos Términos
            de los Servicios de emergencia Botón de pánico ("Términos")
            establecidos en el presente son afirmados por el Suscriptor nombrado
            en relación con cierto Acuerdo de Licencia de Usuario Final ("EULA")
            entre la Compañía nombrada y el Suscriptor en beneficio de Beeapp
            Ecuador, CIA. LTDA., junto con sus licencias. Beeapp Ecuador
            proporciona el servicio de emergencia(Botón de pánico) notificando a
            los contactos de emergencia mediante sms y permitiendo el monitoreo
            del dispositivo durante 24 horas, una vez excedido el tiempo no
            habrá registro de la ubicación. Se regirá por los términos del EULA;
            siempre que, en caso de conflicto entre estos Términos y los
            términos y condiciones del EULA, se considerará que estos Términos
            prevalecen en lo que se refiere a los Servicios de Monitoreo
            únicamente. A menos que se establezca expresamente lo contrario en
            el EULA o sus anexos. El Suscriptor acepta cumplir con estos
            Términos. Para evitar dudas, o datos inconsistentes en Beeapp
            Ecuador.
          </p>

          <details className="mb-4">
            <summary className="cursor-pointer font-medium">
              Señal de emergencia
            </summary>
            <div className="mt-2">
              El Suscriptor reconoce y acepta que la única responsabilidad de
              Beeapp Ecuador al recibir una señal de emergencia transmitida
              desde la aplicación es notificar a los contactos de emergencia
              registrados por SMS el cual contendrá una URL para el rastreo en
              tiempo real del dispositivo(Tracking) siempre y cuando el
              dispositivo tenga acceso a internet. Abonado entiende y acepta que
              Beeapp Ecuador y sus respectivos representantes quedan liberados
              de toda responsabilidad por negligencia activa o pasiva única,
              conjunta o solidaria de cualquier tipo o grado de Beeapp Ecuador o
              sus respectivos representantes que el Suscriptor o cualquier
              persona reclamando a través del Suscriptor, de alguna manera
              podría reclamar contra Beeapp Ecuador o sus respectivos
              representantes con base en, que surja mala conexión, como
              resultado de una falla o el envío inadecuado de servicios de
              emergencia.
            </div>
          </details>

          <details className="mb-6">
            <summary className="cursor-pointer font-medium">
              Falsas alarmas
            </summary>
            <div className="mt-2">
              En caso de que el Sistema se active por cualquier motivo que no
              sea la necesidad de emergencia. (una "Falsa Alarma"), el
              Suscriptor será responsable de las multas, cargos, costos, gastos
              y penalidades que se impongan al Suscriptor, la Compañía, Beeapp
              Ecuador.
            </div>
          </details>
        </section>

        {/* <footer className="text-sm text-neutral-500">
        <p>Última revisión: 15 de agosto de 2022</p>
      </footer> */}
      </article>
      <TermsPage />
      <BackgroundLocationPage />
    </>
  );
};

export default PoliciesPage;
